<select id="mode" [(ngModel)]="hour">
  <option value="none"></option>
  <option *ngFor="let r of hours" [ngValue]="r">{{ r }}</option>
</select>
:
<select id="mode" [(ngModel)]="minute">
  <option value="none"></option>
  <option *ngFor="let r of minutes" [ngValue]="r">{{ ("0" + r).slice(-2) }}</option>
</select>
